import React, { useEffect, useState } from "react";
import Axios from '../utils/Axios';
import Chatbox from '../components/Chatbox';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css';
import HeatMap from '@uiw/react-heat-map';


function FriendsPage() {
  const user = useSelector(state => state.user);
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [chatWithUserId, setChatWithUserId] = useState(null);
  const [Scheduler, setScheduler] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [mapDates, setMapDates] = useState([]);


  const handleDateChange = (date) => {
    setSelectedDate(date);
    const formatted = date.toISOString().split("T")[0].replace(/-/g, "/");
    if (!mapDates.includes(formatted)) {
      setMapDates((prev) => [...prev, formatted]);
    }
  };

  useEffect(() => {
    const fetchFriends = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await Axios.get("/api/user/friends", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setFriends(res.data.friends || res.data); 
      } catch (err) {
        setError("Failed to load friends");
      } finally {
        setLoading(false);
      }
    };

    fetchFriends();
  }, []);

  if (loading) return <p>Loading friends...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div>
      <h2>Your Friends</h2>
      {friends.length === 0 ? (
        <p>You have no friends yet.</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {friends.map(friend => (
            <li
              key={friend._id}
              style={{ marginBottom: '1rem', border: '1px solid #ccc', padding: '1rem' }}
            >
              <h4>{friend.name || friend.username}</h4>
              <div className ="buttons" style={{ display: "grid", gridTemplateColumns: "300px 300px", gap: "1rem"}}>
              <button onClick={() => setChatWithUserId(friend._id)}>
                Chat with {friend.name || friend.username}
              </button>

              <button onClick={() => setScheduler(friend._id)}>
                Make plans with {friend.name || friend.username}
              </button>
              </div>
              <div className = "chatAndPlan" style={{ display: "grid", gridTemplateColumns: "300px 300px", gap: "1rem"}}>
              {chatWithUserId === friend._id && (
                <div style={{ marginTop: '1rem', flex: 1}}>
                  <Chatbox room={[user._id,friend._id].sort().join("")} />
                  <button onClick={() => setChatWithUserId(null)} style={{ marginTop: '0.5rem' }}>
                    Close Chat
                  </button>
                </div>
              )}

              {Scheduler === friend._id && (
                <div style={{ marginTop: '1rem', flex: 1 }}>
                  <div>
                    <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    dateFormat="yyyy/MM/dd"
                    />
                  </div>
                  <div>
                    <HeatMap
                    value={mapDates.map((d) => ({ date: d, count: 1 }))}
                    weekLabels={['', 'Mon', '', 'Wed', '', 'Fri', '']}
                    startDate={new Date('2025/07/01')}
                    />
                  </div>
                  <button onClick={() => setScheduler(null)} style={{ marginTop: '0.5rem' }}>
                    Close Scheduler
                    </button>
                    </div>
              )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default FriendsPage;
